<template>
  <Modal v-model="show" title="个人积分明细导入" :mask-closable="false">
    <Form ref="importForm" :label-width="120" :label-colon="true">
      <FormItem label="模板文件下载">
        <a @click="downloadTemplate">模板文件</a>
      </FormItem>
      <FormItem label="Excel文件">
        <Upload
          ref="upload"
          :format="fileFormat"
          :show-upload-list="false"
          accept=".xlsx"
          :headers="{ Authorization: token }"
          name="file"
          :action="baseUrl + 'api/tIntegralPeopleItem/upload'"
          :before-upload="handleBeforeUpload"
          :on-success="handleSuccess"
          style="display: inline-block; width: 110px; margin-right: 10px"
        >
          <Button icon="ios-cloud-upload-outline">选择文件</Button>
        </Upload>
        <span v-if="file">{{ file.name }}</span>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button type="text" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit">确定</Button>
    </div>
    <Modal class="errorModal" v-model="showError" title="导入提示">
      <p style="white-space: pre-wrap">{{ errorList }}</p>
      <div slot="footer"></div>
    </Modal>
  </Modal>
</template>

<script>
import util from "@/libs/util.js";

export default {
  name: "integralPeopleItemImport",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      baseUrl: util.baseUrl,
      token: localStorage.token,
      show: this.value,
      fileFormat: ["xlsx"],
      file: null,
      showError: false,
      errorList: "",
    };
  },
  watch: {
    value(newValue) {
      this.show = newValue;
      this.file = null;
    },
    show(newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    downloadTemplate() {
      window.open(
        this.baseUrl + "/api/tIntegralPeopleItem/downloadTemplate",
        "_blank"
      );
    },
    handleBeforeUpload(file) {
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (this.fileFormat.indexOf(fileType) < 0) {
        this.$Message.warning("请上传xlsx格式的文件。");
        return false;
      }
      this.file = file;
      return false;
    },
    handleSubmit() {
      if (this.file) {
        this.$Message.loading({
          content: "正在导入信息",
          duration: 0,
        });
        this.$refs.upload.post(this.file);
      } else {
        this.$Message.error("请选择文件");
      }
    },
    handleSuccess(res) {
      this.$Message.destroy();
      this.show = false;
      if (res.code == 200) {
        this.$Message.success("导入成功");
        this.file = null;
      } else {
        this.errorList = res.msg;
        this.showError = true;
      }
      this.$emit("getList");
    },
  },
};
</script>

<style>
.errorModal .ivu-modal-body {
  height: 200px;
  overflow: auto;
}
</style>
